import React, { useState } from 'react';
import ReactDOM from 'react-dom';

// These imports won't work until you fix ./components/index.js
import {
  Feature,
  Loading,
  Preview,
  Search,
  Title
} from './components';

// import Title from './components/Title';

const App = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState({info: {}, records: []});
  const [featuredResults, setFeaturedResults] = useState(null);

  return ( 
    <div className="app">
      <Title />

      <Search
        setIsLoading={ setIsLoading } 
        setSearchResults={ setSearchResults }
        setFeaturedResults={ setFeaturedResults }
      />

      <Preview 
        searchResults={ searchResults } 
        setIsLoading={ setIsLoading } 
        setSearchResults={ setSearchResults } 
        setFeaturedResults={ setFeaturedResults } 
      />

      <Feature 
        featuredResults={ featuredResults } 
        setIsLoading={ setIsLoading } 
        setSearchResults={ setSearchResults }
      />
      
      { 
        isLoading ? 
          <Loading /> 
        : null 
      }
  </div>
  )
}

ReactDOM.render(<App />, document.getElementById('app'));